<template>
  <fragment>
    <v-flex
      md8
      xs12
    >
      <v-list
        v-if="petList && petList.length > 0"
        class="pet-list"
      >
        <v-list-tile
          v-for="(pet, index) in petList"
          :key="pet.id"
          inactive
          color="basic"
          :class="{ 'background-dark': isOdd(index + 1), pet }"
        >
          <v-list-tile-content>
            <v-list-tile-title
              class="font-weight-bold"
              v-text="pet.name"
            />
          </v-list-tile-content>

          <v-list-tile-action>
            <v-btn
              flat
              icon
              @click="dialog = true"
            >
              <v-icon
                color="basic"
                @click="$emit('openEditDialog', pet)"
              >
                edit
              </v-icon>
            </v-btn>
          </v-list-tile-action>

          <v-list-tile-action>
            <v-btn
              flat
              icon
            >
              <v-icon
                color="basic"
                @click="$emit('openDeleteDialog', pet)"
              >
                delete
              </v-icon>
            </v-btn>
          </v-list-tile-action>
        </v-list-tile>
      </v-list>
      <div
        v-else
        class="title font-weight-regular"
      >
        {{ $t('messages.addPet') }}
      </div>
    </v-flex>
  </fragment>
</template>

<script>
import { Fragment } from 'vue-fragment'
import { mapState, mapActions } from 'vuex'
import { PET_LIST_KEY, ACTION_GET_PETS } from '../../store/types/pets.types'

export default {
  name: 'PetList',
  components: {
    Fragment,
  },
  computed: {
    ...mapState({
      petList: state => state.pets[PET_LIST_KEY],
    }),
  },
  mounted() {
    this.getPets()
  },
  methods: {
    isOdd(index) {
      return index % 2 === 1
    },
    ...mapActions({
      getPets: ACTION_GET_PETS,
    }),
  },

}
</script>

<style lang="stylus" scoped>
  .pet {
    border: 1px var(--v-primary-lighten) solid
  }
  .background-dark {
    background: var(--v-primary-lighten)
  }
</style>
